import React from "react";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";

export default class Workinprogress extends React.Component{
   constructor(props){
      super(props);
      this.state = {
        loading: true
      }
   }
   componentDidMount() {
    this.setState({loading: false});
   }
   render(){
    let content = this.state.loading ? <LoadSpinner/>:

    <div id="wrapper">
    
      <Menucustom/>
        <div className="container-fluid">
            <br/>
            <br/>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
            
              <h1 className="h1 mb-2 text-gray-800">Work in progress!!!</h1>

            </div>
              <br/>
              <br/>
              <div className="col-xl-5 col-lg-0">
                  <div className="card shadow mb-8">
                    <img src="https://www.provincia.vicenza.it/immagini/work_in_porgress_.jpg/image" alt="Lavori in corso" width="600" height="450"/>
                  </div>
              </div>
            
            </div>
      </div>
    return ( 
        <div>{content}</div>
    );
   }
}